import { Png, Svg } from 'common/assets'
import { Button } from 'components/buttons'
import { Styled } from 'components/Styled'
import { useState } from 'react'
import { MenuImage } from './styled'

export const Menu = () => {
  const [page, setPage] = useState<number>(0)

  const images = [Png.GeneralMenu, Png.GeneralMenu, Png.GeneralMenu]
  const image = images[page]

  const isRightButtonDisabled = page === images.length - 1
  const isLeftButtonDisabled = page === 0

  const onRightButton = () => {
    page !== images.length - 1 && setPage(state => state + 1)
  }

  const onLeftButton = () => {
    page != 0 && setPage(state => state - 1)
  }

  return (
    <>
      <Styled.FlexWrapper direction="column" width={'100%'} gap={28}>
        {/* Menu */}
        <MenuImage src={image} />

        <Styled.FlexWrapper gap={47} width={'100%'}>
          <Styled.Hr />

          <Styled.FlexWrapper gap={22}>
            <Button.Position
              position={'left'}
              onClick={onLeftButton}
              disabled={isLeftButtonDisabled}
            />

            <Button.Position
              position={'right'}
              onClick={onRightButton}
              disabled={isRightButtonDisabled}
            />
          </Styled.FlexWrapper>
        </Styled.FlexWrapper>
      </Styled.FlexWrapper>
    </>
  )
}
